<template>
  <div class="devpage4-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devpage4-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-right="devconfigshow = true" @click-left="gotohome">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #right>
            <van-icon name="setting-o" size="20px" color="#94a3b8" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">{{ did }}</span>
            </div>
          </template>
        </van-nav-bar>

        <van-action-sheet v-model="devconfigshow" :actions="actions" cancel-text="取消" @select="onSelect"
          :title="devdata.udname" class="crystal-actionsheet" />

        <DevGroup v-if="devgroupcard" :did="devdata.did" @configstatus="configstatus($event)"></DevGroup>
        <DevName v-if="devnamecard" :did="devdata.did" @configstatus="configstatus($event)"></DevName>
        <DevUnbind v-if="devunbindcard" :did="devdata.did" @configstatus="configstatus($event)"></DevUnbind>

        <div class="status-block" :class="statusBlockClass">
          <div class="status-inner">
            <div class="status-text">{{ stTitle }}</div>
            <div v-if="heroSub" class="status-sub">{{ heroSub }}</div>
            <div v-if="pendingWcTip" class="status-tip">自动换水等待中</div>
            <div v-if="maintWaitTip" class="status-tip">维护将在当前操作结束后生效</div>
            <div class="status-time" :class="{ 'status-time--offline': offline }">
              {{ offline ? "设备离线 · 最后更新 " : "更新时间 " }}{{ devdata.time }}
            </div>
          </div>
        </div>

        <div v-if="!mqttConnected" class="mqtt-offline-tip">
          实时连接已断开，以下可能是旧数据，正在自动重连…
        </div>

        <div class="quick-control">
          <!-- 待机/维护模式：手动排水/手动补水 + 一键换水占满 -->
          <button v-if="showCtrlBtns" class="ctrl-btn ctrl-btn--drain" :disabled="sending" @click="cmdDrain">
            手动排水
          </button>
          <button v-if="showCtrlBtns" class="ctrl-btn ctrl-btn--fw" :disabled="sending" @click="cmdFill">
            手动补水
          </button>
          <button v-if="showCtrlBtns" class="ctrl-btn ctrl-btn--wc ctrl-btn--full" :disabled="sending" @click="cmdWc">
            一键换水
          </button>
          <!-- 运行中：停止按钮 -->
          <button v-if="showStopButton" class="ctrl-btn ctrl-btn--danger ctrl-btn--full" :disabled="sending"
            @click="cmdStop">
            停止
          </button>
        </div>

        <div v-if="showFaultBanner" class="error-banner">
          <div class="error-banner-left">
            <span class="iconfont icon-gongju error-banner-icon"></span>
          </div>
          <div class="error-banner-body">
            <div class="error-banner-title">设备告警</div>
            <div class="error-banner-text">{{ faultName || "设备故障锁定，请清除故障后重试" }}</div>
          </div>
          <button v-if="canClearFault" class="error-clear-btn" :disabled="sending" @click="cmdClearFault">清除</button>
        </div>

        <div class="content-area">
          <div class="info-card">
            <div class="info-item">
              <div class="info-item-left">
                <span class="iconfont icon-gongzuomoshi info-icon" style="color:#fb923c"></span>
                <span class="info-label">维护模式</span>
              </div>
              <van-switch :value="maintOn" size="22" :loading="maintLoading" :disabled="sending"
                @change="onMaintChange" />
            </div>
            <div class="info-divider"></div>
            <div class="info-item" v-for="(item, index) in statusItems" :key="index">
              <div class="info-item-left">
                <span class="iconfont" :class="item.icon" :style="{ color: item.color }"></span>
                <span class="info-label">{{ item.label }}</span>
              </div>
              <span class="info-value" :class="item.valueClass">{{ item.value }}</span>
            </div>
          </div>

          <div class="info-card">
            <div class="info-item info-item--link" @click="gotoconfig()">
              <div class="info-item-left">
                <span class="iconfont icon-sinaweibo18 info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">参数设置</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <div class="info-divider"></div>
            <div class="info-item info-item--link" @click="gotolog()">
              <div class="info-item-left">
                <span class="iconfont icon-rizhi info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">历史记录</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import DevGroup from "../general/apidevgroup.vue";
import DevName from "../general/apidevname.vue";
import DevUnbind from "../general/apidevunbind.vue";

/* 顶部状态文字（开发说明 V1.1 §20"小程序状态"表，st 对应 app_protocol.h APP_ST_* 0~11） */
const ST_NAMES = [
  "正在初始化水路",   // 0 开机BC校准（剩余10秒）
  "待机",             // 1 BC待机
  "维护模式",         // 2 维护空闲
  "",                 // 3 排水前检查（瞬时状态，§20 未定义，不显示）
  "正在切换排水水路", // 4 排水前灌水（剩余3秒）
  "正在排水",         // 5 AB排水
  "正在切换补水水路", // 6 正常切换BC（剩余10秒）
  "正在自动补水",     // 7 自动换水补水
  "正在手动补水",     // 8 按键或平台补水
  "正在补充蒸发水",   // 9 独立补水
  "正在初始化水路",   // 10 强制安全回BC（剩余15秒）
  "故障",             // 11 故障锁定（显示具体故障名称）
];

/* 当前任务 sub（s_sm.sub，TASK_*，见 §3.2） */
const SUB_NAMES = ["无任务", "自动换水", "手动排水", "手动补水", "独立补水"];

const LEVEL_NAMES = ["满水", "半水", "低水位", "传感器异常"];

/* 故障码 err（app_protocol.h APP_ERR_*） */
const FAULT_NAMES = [
  "",
  "水位传感器异常",       // 1 APP_ERR_LEVEL_BAD
  "排水超时",             // 2 APP_ERR_DRAIN_TIMEOUT
  "换水补水超时",         // 3 APP_ERR_WC_FILL_TIMEOUT
  "独立补水超时",         // 4 APP_ERR_FILL_TIMEOUT
  "程序输出互锁异常",     // 5 APP_ERR_INTERLOCK
  "排水无流量",           // 6 APP_ERR_DRAIN_NO_FLOW 定量模式连续无脉冲
];

export default {
  name: "DevPageKD4",
  components: { DevGroup, DevName, DevUnbind },
  data() {
    return {
      devconfigshow: false,
      devgroupcard: false,
      devnamecard: false,
      devunbindcard: false,
      isLoading: false,
      maintLoading: false,
      sending: false,
      devdata: null,
      did: this.$route.query.did,
      /* 今日换水量（ml）：查历史日志汇总，null=无数据未统计 */
      todayDrainMl: null,
      /* MQTT 实时订阅（同 KD-3：订阅 d2s，接收周期 heart 与状态变化 heart/reconfig） */
      connection: {
        url: "wss://dev.kudutech.cn/mqtt",
        clean: true,
        clientId: this.$route.query.did + this.generateUUID(),
        username: "KD-4web",
        password: "KD-4web",
      },
      subscription: {
        topic: "kd/dev/KD-4/" + this.$route.query.did + "/d2s",
        qos: 1,
      },
      client: {
        connected: false,
      },
      /* MQTT 实时通道状态：false=未连接（页面显示的可能是旧数据） */
      mqttConnected: false,
      actions: [
        { name: "更改分组", color: "#2dd4bf" },
        { name: "重命名", color: "#2dd4bf" },
        { name: "参数设置", color: "#2dd4bf" },
        { name: "历史记录", color: "#2dd4bf" },
        { name: "解绑", color: "#fb7185" },
      ],
    };
  },
  mounted() {
    this.GetDevData(this.did);
    this.fetchTodayDrain();
    this.createConnection();
  },
  watch: {
    /* 排水结束（离开排水状态）后刷新今日换水量汇总 */
    st(newV, oldV) {
      if (oldV === 5 && newV !== 5) this.fetchTodayDrain();
    },
  },
  beforeDestroy() {
    if (this.client.connected) {
      try {
        this.client.end();
        this.client = { connected: false };
      } catch (error) { }
    }
  },
  computed: {
    v() {
      return this.devdata && this.devdata.value ? this.devdata.value : {};
    },
    st() {
      return this.v.st != null ? this.v.st : -1;
    },
    stName() {
      if (this.st < 0 || this.st >= ST_NAMES.length) return "--";
      return ST_NAMES[this.st];
    },
    /* §20：标题带"（剩余N秒）"；故障锁定显示具体故障名称 */
    stTitle() {
      if (this.st === 11) return this.faultName || "故障";
      let title = this.stName;
      if (this.v.remain != null && this.v.remain > 0) {
        title += "（剩余 " + this.v.remain + " 秒）";
      }
      return title;
    },
    /* §20 补充显示规则 */
    heroSub() {
      /* 故障触发安全回BC：顶部保持"正在初始化水路"，另外显示具体故障原因 */
      if (this.st === 10 && this.fault) {
        return this.faultName || "故障";
      }
      /* 维护模式：显示维护剩余（maint_left，-1=不适用/长期） */
      if (this.st === 2) {
        if (this.v.maint_left != null && this.v.maint_left > 0) {
          return "维护剩余 " + this.formatSec(this.v.maint_left);
        }
        return "长期维护，自动任务已暂停";
      }
      /* 运行中的工作状态：显示当前任务 */
      if (this.st >= 5 && this.st <= 9 && this.sub > 0) {
        return "当前任务：" + this.subName;
      }
      return "";
    },
    fault() {
      const err = this.devdata && this.devdata.err;
      return Array.isArray(err) && err.length > 0 && err[0] !== 0;
    },
    faultCode() {
      const err = this.devdata && this.devdata.err;
      return Array.isArray(err) && err.length > 0 ? err[0] : 0;
    },
    faultAddCode() {
      const err = this.devdata && this.devdata.err;
      return Array.isArray(err) && err.length > 1 ? err[1] : 0;
    },
    faultName() {
      const names = [];
      if (this.faultCode > 0 && this.faultCode < FAULT_NAMES.length) {
        names.push(FAULT_NAMES[this.faultCode]);
      }
      if (this.faultAddCode > 0 && this.faultAddCode < FAULT_NAMES.length &&
          this.faultAddCode !== this.faultCode) {
        names.push(FAULT_NAMES[this.faultAddCode]);
      }
      return names.join("；");
    },
    showFaultBanner() {
      return this.fault || this.st === 11;
    },
    pendingWcTip() {
      return this.st === 9 && this.v.pending_wc === 1;
    },
    maintWaitTip() {
      return this.v.maint_wait === 1;
    },
    /* 设备离线（后端 LWT 驱动）：状态块置灰，避免旧数据被误读为当前状态 */
    offline() {
      return this.devdata.status === "离线";
    },
    /* 状态块配色（同 KD-3：待机青/补水蓝/排水换水紫/维护橙/告警红） */
    statusBlockClass() {
      if (this.offline) return "status-block--offline";
      if (this.fault || this.st === 11) return "status-block--alert";
      if (this.st === 2) return "status-block--maintain";
      if (this.st === 7 || this.st === 8 || this.st === 9) return "status-block--replenish";
      if (this.st >= 3 && this.st <= 10) return "status-block--wc";
      return "status-block--idle";
    },
    level() {
      return this.v.level != null ? this.v.level : -1;
    },
    levelName() {
      if (this.level < 0 || this.level >= LEVEL_NAMES.length) return "--";
      return LEVEL_NAMES[this.level];
    },
    /* 当前任务 sub（s_sm.sub，TASK_*） */
    sub() {
      return this.v.sub != null ? this.v.sub : 0;
    },
    subName() {
      if (this.sub < 0 || this.sub >= SUB_NAMES.length) return "--";
      return SUB_NAMES[this.sub];
    },
    h7Name() {
      const n = Number(this.v.h7);
      return n === 1 ? "有水" : n === 0 ? "无水" : "--";
    },
    h8Name() {
      const n = Number(this.v.h8);
      return n === 1 ? "有水" : n === 0 ? "无水" : "--";
    },
    outputName() {
      const a = this.devdata && this.devdata.action ? this.devdata.action : {};
      const parts = [];
      if (a.ab) parts.push("AB排水路");
      if (a.bc) parts.push("BC水路");
      if (a.pump) parts.push("水泵");
      if (a.valve) parts.push("电磁阀");
      return parts.length ? parts.join(" + ") : "全部关闭";
    },
    flowText() {
      if (this.v.flow_ml == null || this.v.flow_ml < 0) return "未统计";
      const cur = (this.v.flow_ml / 1000).toFixed(2);
      /* 定量排水运行中：显示已排/目标进度（设备排水期间实时上报） */
      if (this.st === 5 && this.drainMode === 2) {
        return "已排 " + cur + "L / 目标 " + this.drainTargetText;
      }
      return cur + " L";
    },
    /* 排水模式（config.drain_mode 0=区间(固件排空) 1=定时 2=定量） */
    drainMode() {
      const c = this.devdata && this.devdata.config;
      return c && c.drain_mode != null ? Number(c.drain_mode) : 0;
    },
    drainTargetText() {
      const c = this.devdata && this.devdata.config;
      const t = c && c.drain_target != null ? Number(c.drain_target) : 0;
      return t > 0 ? (t / 10).toFixed(1) + "L" : "--";
    },
    drainModeText() {
      if (this.drainMode === 1) {
        const c = this.devdata && this.devdata.config;
        const mins = c && c.drain_timeout_min != null ? c.drain_timeout_min : "--";
        return "定时 " + mins + " 分钟";
      }
      if (this.drainMode === 2) return "定量 " + this.drainTargetText;
      return "区间（至低水位）";
    },
    /* 今日换水量：查历史日志汇总当天 drain_done 的 ml 值（不含硬件字段） */
    todayText() {
      if (this.todayDrainMl == null) return "未统计";
      return (this.todayDrainMl / 1000).toFixed(2) + "L";
    },
    /* 下次自动换水：仅手动=设备不会自动换水，任务进行中=正在换，其余看设备排定时刻 */
    nextWcText() {
      const c = this.devdata && this.devdata.config;
      if (c && c.wc_mode != null && Number(c.wc_mode) === 2) return "仅手动";
      if (this.sub === 1) return "换水中";
      return this.fmtNext(this.v.next_wc);
    },
    /* 下次独立补水：功能关闭时设备不上报排定时刻 */
    nextEvapText() {
      const c = this.devdata && this.devdata.config;
      if (c && c.evap_enable != null && Number(c.evap_enable) === 0) return "已关闭";
      if (this.sub === 4) return "补水中";
      return this.fmtNext(this.v.next_evap);
    },
    statusItems() {
      const items = [];
      items.push({
        icon: "icon-shuiwei",
        color: this.level === 3 ? "#ef4444" : "#0ea5e9",
        label: "水位",
        value: this.levelName + "（高" + this.h7Name + " / 低" + this.h8Name + "）",
        valueClass: this.level === 3 ? "info-value--warn" : this.level === 0 ? "info-value--active" : "",
      });
      items.push({
        icon: "icon-shuiwei",
        color: "#64748b",
        label: "排水模式",
        value: this.drainModeText,
        valueClass: "",
      });
      items.push({
        icon: "icon-bushuitubiao",
        color: "#f97316",
        label: "本次排水量",
        value: this.flowText,
        valueClass: this.st === 5 ? "info-value--active" : "",
      });
      items.push({
        icon: "icon-bushuitubiao",
        color: "#10b981",
        label: "今日换水量",
        value: this.todayText,
        valueClass: "",
      });
      items.push({
        icon: "icon-daojishi",
        color: "#0ea5e9",
        label: "下次自动换水",
        value: this.nextWcText,
        valueClass: "",
      });
      items.push({
        icon: "icon-daojishi",
        color: "#8b5cf6",
        label: "下次独立补水",
        value: this.nextEvapText,
        valueClass: "",
      });
      return items;
    },
    /* 待机/维护：三按钮；运行中：停止（同 KD-3 互斥逻辑） */
    showCtrlBtns() { return !this.showFaultBanner && (this.st === 1 || this.st === 2); },
    showStopButton() { return !this.showFaultBanner && this.st >= 3 && this.st <= 9; },
    canClearFault() { return this.st === 11; },
    maintOn() { return this.st === 2; },
  },
  methods: {
    gotohome() { this.$router.go(-1); },
    /* 今日换水量：查当天历史日志，汇总 drain_done 的 "Nml" 值；
     * 全部为 unmeasured（流量计未启用）或无记录 → null 显示"未统计" */
    fetchTodayDrain() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/history", qs.stringify({
          did: this.did, dtype: "KD-4", history: "log", tnum: 1, tunit: "day",
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            const buf = response.data.data && response.data.data.log_buf;
            const logs = Array.isArray(buf) ? buf : [];
            const d = new Date();
            const p = (n) => (n < 10 ? "0" + n : "" + n);
            const prefix = d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate());
            let sum = null;
            for (let i = 0; i < logs.length; i++) {
              const e = logs[i];
              if (e.name !== "drain_done" || String(e.time || "").indexOf(prefix) !== 0) continue;
              const m = /^(\d+)ml$/.exec(String(e.val || ""));
              if (m) sum = (sum == null ? 0 : sum) + parseInt(m[1], 10);
            }
            this.todayDrainMl = sum;
          }
        })
        .catch(() => { });
    },
    /* ============ MQTT 实时订阅（KA-1 模式） ============ */
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now();
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    createConnection() {
      const { url, ...options } = this.connection;
      try {
        if (!this.client.connected) {
          this.client = mqtt.connect(url, options);
        }
      } catch (error) { }
      /* 连接成功（含断线自动重连）：首次进入补订阅，之后每次都向设备
         要一次当前状态，防止断连期间页面一直停留在旧数据 */
      this.client.on("connect", () => {
        this.mqttConnected = true;
        console.log("MQTT Connection succeeded!");
        if (!this._subscribed) {
          this._subscribed = true;
          this.doSubscribe();
        } else {
          this.requestSync();
        }
      });
      this.client.on("error", (error) => {
        this.mqttConnected = false;
        console.warn("MQTT error:", error);
      });
      this.client.on("close", () => {
        this.mqttConnected = false;
      });
      this.client.on("message", (topic, message) => {
        var datastr = `${message}`.replace(/\'/g, '"');
        this.resolve_data(JSON.parse(datastr));
      });
    },
    doSubscribe() {
      try {
        const { topic, qos } = this.subscription;
        this.client.subscribe(topic, qos, (error, res) => {
          if (error) return;
          /* 订阅成功后等 MQTT 通道就绪，再请求设备立即回传一次当前状态，
             实现打开页面时尽可能同步（设备回 reconfig，d2s 订阅收到即更新） */
          setTimeout(() => this.requestSync(), 300);
        });
      } catch (error) {
        console.warn("MQTT subscribe failed:", error);
      }
    },
    /* 主动请求设备回传一次当前状态（空配置 → 设备回 reconfig） */
    requestSync() {
      const qs = require("qs");
      var databuf = JSON.stringify({});
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did, d_type: "KD-4", config: databuf,
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            /* 设备已回 reconfig；后台缓存也已更新，HTTP 兜底再拉一次 */
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
          /* 406 设备不在线等：保留已显示的缓存 */
        })
        .catch(() => { });
    },
    resolve_data(data_buf) {
      /* 同 KD-3：处理周期/即时 heart 与配置保存后的 reconfig */
      if (data_buf["m_type"] === "heart" || data_buf["m_type"] === "reconfig") {
        if (data_buf.value) this.devdata.value = data_buf.value;
        this.devdata.err = data_buf.err || [0];
        if (data_buf.action) this.devdata.action = data_buf.action;
        /* heart 通常带全量 config：缺失时保留旧值，避免参数行瞬时闪烁 */
        if (data_buf.config) {
          this.devdata.config = data_buf.config;
        }
        if (data_buf.sta) {
          this.devdata.sta = data_buf.sta;
        }
        /* 收到实时报文说明设备已恢复在线（后端 LWT 置离线后重连场景） */
        this.devdata.status = "在线";
        this.$forceUpdate();
      }
    },
    gotoconfig() {
      this.$router.push({ name: "KD4Config", query: { did: this.did } });
    },
    gotolog() {
      this.$router.push({
        name: "KD4Log",
        query: { did: this.did, udname: this.devdata ? this.devdata.udname : "" },
      });
    },
    fmtEpoch(epoch) {
      if (!epoch || epoch <= 0) return "未安排";
      const d = new Date(epoch * 1000);
      const p = (n) => (n < 10 ? "0" + n : "" + n);
      return p(d.getMonth() + 1) + "-" + p(d.getDate()) + " " + p(d.getHours()) + ":" + p(d.getMinutes());
    },
    /* 设备排定时刻显示：未校时时排定值无意义；已到期用设备自身时间戳判定（避免浏览器时钟偏差） */
    fmtNext(epoch) {
      const e = Number(epoch) || 0;
      const t = this.v || {};
      if (t.time_ok === 0 || t.time_ok === false) return "设备未校时";
      if (e <= 0) return "未安排";
      const devNow = Number(t.now) || 0;
      if (devNow > 0 && e <= devNow) return "已到期";
      return this.fmtEpoch(e);
    },
    formatSec(sec) {
      if (sec == null || sec <= 0) return "0秒";
      if (sec < 60) return sec + "秒";
      if (sec < 3600) return Math.floor(sec / 60) + "分" + (sec % 60) + "秒";
      return Math.floor(sec / 3600) + "时" + Math.floor((sec % 3600) / 60) + "分";
    },
    onSelect(item) {
      this.devconfigshow = false;
      if (item.name === "重命名") { this.devnamecard = true; }
      else if (item.name === "更改分组") { this.devgroupcard = true; }
      else if (item.name === "参数设置") { this.gotoconfig(); }
      else if (item.name === "历史记录") { this.gotolog(); }
      else if (item.name === "解绑") { this.devunbindcard = true; }
    },
    configstatus(statu) {
      this.devgroupcard = false;
      this.devnamecard = false;
      this.devunbindcard = false;
      this.GetDevData(this.did);
      if (statu === true) { this.$toast.success("设置成功"); }
    },
    /* 快捷操作（操作前弹确认框，同 KD-3） */
    confirmAction(message, action) {
      this.$dialog.confirm({
        title: "操作确认",
        message: message,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        action();
      }).catch(() => { });
    },
    cmdWc() {
      this.confirmAction("确定执行一键换水吗？将自动完成排水和补水。", () => {
        this.sendCmd({ wc: 1 }, "一键换水");
      });
    },
    cmdDrain() {
      this.confirmAction("确定执行手动排水吗？", () => {
        this.sendCmd({ drain: 1 }, "手动排水");
      });
    },
    cmdFill() {
      this.confirmAction("确定执行手动补水吗？", () => {
        this.sendCmd({ fill: 1 }, "手动补水");
      });
    },
    cmdStop() {
      this.confirmAction("确定停止当前运行吗？", () => {
        this.sendCmd({ stop: 1 }, "停止");
      });
    },
    cmdClearFault() {
      this.confirmAction("确定清除设备故障吗？", () => {
        this.sendCmd({ clear_fault: 1 }, "清除故障");
      });
    },
    onMaintChange(val) {
      this.maintLoading = true;
      const cmd = val ? { maint: 1 } : { maint_exit: 1 };
      this.doSend(cmd, val ? "进入维护" : "退出维护", () => {
        this.maintLoading = false;
        this.GetDevData(this.did);
      });
    },
    sendCmd(cmdObj, tip) {
      this.doSend(cmdObj, tip, () => {
        this.GetDevData(this.did);
      });
    },
    doSend(cmdObj, tip, after) {
      this.sending = true;
      const databuf = JSON.stringify({ cmd: cmdObj });
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({ did: this.did, d_type: "KD-4", config: databuf }))
        .then((response) => {
          this.sending = false;
          if (response.data.error_code === 0) {
            this.$notify({ type: "success", message: tip + "指令已发送" });
            if (after) after();
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else if (response.data.error_code === 406) {
            this.$notify({ type: "danger", message: "设备不在线" });
            if (after) after();
          } else {
            this.$notify({ type: "danger", message: tip + "指令发送失败" });
            if (after) after();
          }
        })
        .catch(() => {
          this.sending = false;
          this.$notify({ type: "danger", message: "网络错误" });
          if (after) after();
        });
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.devdata = response.data;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$router.push({ path: "/devlist" });
          }
        });
    },
    onReflash() {
      var databuf = JSON.stringify({});
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({ did: this.did, d_type: "KD-4", config: databuf }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.isLoading = false;
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.isLoading = false;
            this.$notify({ type: "danger", message: "刷新失败！" });
          }
        });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.mqtt-offline-tip {
  margin: 8px 16px 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: #fef3c7;
  color: #b45309;
  font-size: 12px;
  text-align: center;
}

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.crystal-nav .van-nav-bar__title {
  max-width: 70%;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

.crystal-actionsheet .van-action-sheet__header {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}
</style>

<style scoped>
.devpage4-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.devpage4-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.status-block {
  position: relative;
  margin: 12px 12px 0;
  border-radius: 18px;
  padding: 40px 24px;
  text-align: center;
  overflow: hidden;
  transition: all 0.4s ease;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
}

.status-block--idle {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
}

.status-block--replenish {
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  color: #fff;
}

.status-block--wc {
  background: linear-gradient(135deg, #a78bfa, #8b5cf6);
  color: #fff;
}

.status-block--maintain {
  background: linear-gradient(135deg, #fb923c, #f97316);
  color: #fff;
}

.status-block--alert {
  background: linear-gradient(135deg, #f87171, #ef4444);
  color: #fff;
}

/* 离线：灰调，提示展示的是最后缓存数据 */
.status-block--offline {
  background: linear-gradient(135deg, #94a3b8, #64748b);
  color: #fff;
}

.status-block--replenish::before,
.status-block--wc::before,
.status-block--maintain::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.08) 0%, transparent 60%);
  animation: statusShimmer 4s ease-in-out infinite;
}

@keyframes statusShimmer {

  0%,
  100% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(10%, 10%);
  }
}

.status-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.status-text {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
}

.status-sub {
  font-size: 14px;
  font-weight: 400;
  opacity: 0.85;
  margin-top: 4px;
}

.status-tip {
  display: inline-block;
  margin-top: 8px;
  padding: 3px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
}

.status-time {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.65;
  margin-top: 6px;
}

.status-time--offline {
  opacity: 0.9;
}

.quick-control {
  margin: 10px 12px 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  background: #ffffff;
  border-radius: 16px;
  padding: 12px 14px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}

.ctrl-btn {
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
}

.ctrl-btn:active {
  transform: scale(0.95);
}

.ctrl-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.ctrl-btn--fw {
  background: rgba(56, 189, 248, 0.15);
  color: #0284c7;
}

.ctrl-btn--fw:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(56, 189, 248, 0.25);
}

.ctrl-btn--drain {
  background: rgba(251, 146, 60, 0.15);
  color: #ea580c;
}

.ctrl-btn--drain:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(251, 146, 60, 0.25);
}

.ctrl-btn--wc {
  background: rgba(167, 139, 250, 0.15);
  color: #7c3aed;
}

.ctrl-btn--wc:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(167, 139, 250, 0.25);
}

.ctrl-btn--danger {
  background: rgba(239, 68, 68, 0.12);
  color: #dc2626;
}

.ctrl-btn--danger:not(:disabled):active {
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.25);
}

.ctrl-btn--full {
  grid-column: 1 / -1;
}

.error-banner {
  margin: 10px 12px 0;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-left: 4px solid #ef4444;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.error-banner-left {
  flex-shrink: 0;
}

.error-banner-icon {
  font-size: 18px;
  color: #ef4444;
}

.error-banner-body {
  flex: 1;
  min-width: 0;
}

.error-banner-title {
  font-size: 13px;
  font-weight: 600;
  color: #991b1b;
  margin-bottom: 2px;
}

.error-banner-text {
  font-size: 12px;
  color: #b91c1c;
  line-height: 1.5;
}

.error-clear-btn {
  flex-shrink: 0;
  height: 28px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  background: #ef4444;
  color: #fff;
  transition: transform 0.15s, box-shadow 0.15s;
  white-space: nowrap;
}

.error-clear-btn:active {
  transform: scale(0.95);
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

.error-clear-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
  min-height: 20px;
}

.info-item--link {
  cursor: pointer;
  transition: background 0.15s;
}

.info-item--link:active {
  background: #f8fafc;
}

.info-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.info-icon {
  font-size: 17px;
  flex-shrink: 0;
}

.info-label {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
}

.info-value {
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  text-align: right;
  margin-left: 12px;
  flex-shrink: 0;
  max-width: 55%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-value--active {
  color: #0d9488;
}

.info-value--warn {
  color: #ef4444;
}

.info-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}
</style>
